import {
  FETCH_THING_REQUEST,
  FETCH_THING_SUCCESS,
  FETCH_THING_FAILURE,
  RESET_THING_STATE,
} from "../actions/thing.actions";

const initialState = {
  data: null,
  loading: false,
  success: false,
  error: false,
};

const thing = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_THING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_THING_SUCCESS:
      return {
        ...state,
        data: action.payload,
        success: true,
        loading: false,
        error: null,
      };
    case FETCH_THING_FAILURE:
      return {
        ...state,
        data: null,
        loading: false,
        error: action.payload,
        success: false,
      };
    case RESET_THING_STATE:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default thing;
